import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Loader from '../../components/utils/Loader';
import useFetch from '../../hooks/useFetch';
import SpeechInputComponent from '../../components/SpeechInputComponent';

import AILightComponent from '../../components/AILightComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faMicrophone, faMicrophoneSlash, faTimes } from '@fortawesome/free-solid-svg-icons';
import { 
  faLightbulb, faTools, faLayerGroup, faPuzzlePiece, faClipboardList, 
  faRocket, faPiggyBank, faBullseye, faHeartbeat, faLeaf, 
  faSlidersH, faBook, faHandsHelping, faQuestionCircle, faExclamationCircle, faPlusCircle
} from "@fortawesome/free-solid-svg-icons";
import '../../styles/Concerns.css';
import { GenerateRCACode } from '../../components/GenerateThink5whysCode';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


const Rca = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const { userId, setUserId } = useState(authState.user._id);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const { userName, setUserName } = useState(authState.user.name);

  const [rcaBookStatus, setRcaBookStatus] = useState(false);

  const { rcaId } = useParams();
  const mode = rcaId === undefined ? "add" : "update";
  const [rca, setRca] = useState(null);
  
  const [error, setError] = useState(null);
  const [autoRCACode, setAutoRCACode] = useState(GenerateRCACode());
  const [isCheckedAISupport, setIsCheckedAISupport] = useState(false);
  const [showMicrophoneAlert, setShowMicrophoneAlert] = useState(false);
  const [showSolutionNotes, setShowSolutionNotes] = useState(false);

  const [countFormErrors, setCountFormErrors] = useState(0);
  
  const [formData, setFormData] = useState({
    userRCAID: 'MYRCA1',
    rcaType: "Problem",
    rcaFor: "Self",
    category: "",
    subCategory: "",
    concernArea: "",
    problemStatement: "",
    why1: "",
    why2: "",
    why3: "",
    why4: "",
    why5: "",
    rootCause: "",
    tags: "",
    summary: "",
    remarks: "",
    hasStatementAddOn: false,
    hasWhy1AddOn: false,
    hasWhy2AddOn: false,
    hasWhy3AddOn: false,
    hasWhy4AddOn: false,
    hasWhy5AddOn: false,
    hasRootCauseAddOn: false,
    hasSolutionAddOn: false,
    hasActionsAddOn: false,
    hasBeforeAfterAddOn: false,
    isApproved: false,
    isFinal: false,
    dateCreated: new Date(),
    dateUpdated: new Date(),
    isActive: true,
    isDeleted: false,
    isPublic: false,
    isShared: false,
    rcaCode: autoRCACode,
    pairCode: '',
    teamCode: '',
    teamName: '',
    taskCode: '',
    taskLinkDate: null,
    linkedRCACode: '',  
    quickSolutionsNote: '',
    quickSolutionsSelectionNote: '',
    quickSolutionsActionsNote: '',
    quickImpactNotes: '',

    department: '',
    region: '',
    district: '',    
    village: '',    
    state: '',   
    country: 'India', 
    isCompleted: false,
    completionDate: null,
    isRecurring: false,
    isPriority: false,
    status: '',

    isSheetal: false,
    ownerCode: userCode,
    ownerName: userName,
    masterOwnerCode: 'NA',
    masterOwnerName: 'NA',
    subDepartment: '',
    subDistrict: '',
    block: '',
    sheetalRemarks: '',

    isInspire: false,
    student: '',
    school: '',
    session: '',
    studentClass: '',
    section: '',
    teacher: '',
    principal: '',
    admin: '',
    inspireRemarks: '',

    isFinwiser: false,
    branch:'',
    subBranch: '',
    manager: '',
    employee: '',
    customer: '',
    consultant: '',
    partner: '',
    finwiserRemarks: '',

    isSports: false,
    coach: '',
    assistantCoach: '',
    player: '',
    ground: '',
    tournament: '',
    sportsRemarks: '',

    isHealth: false,
    patient: '',
    doctor: '',
    hospital: '',
    headDoctor: '',
    speciality: '',
    healthRemarks: '',

    isAgri: false,
    farmer: '',
    helper: '',
    supervisor: '',
    manager: '',
    crop: '',
    area: '',
    agriRemarks: '',

    assistant: '',
    supervisor: '',

    rcaFromDate: new Date(),
    rcaToDate: new Date(),

    rcaGroupCode: "",
  });

  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    document.title = mode === "add" ? "Add" : "Update";
  }, [mode]);

  useEffect(() => {
    const config = { 
      url: `/mybooks/think5whysbookbuyingstatus`, 
      method: "post", 
      headers: { Authorization: authState.token },
      data: {userId: userId} 
    };

    fetchData(config, { showSuccessToast: false })
      .then((data) => {
        // console.log("response for update",data);
        setRcaBookStatus(true);
    })
    .catch((error) => {
      console.error("Error fetching Think5Whys Main BOK status:", error);
      setError("Error fetching Think5Whys Main BOK status");
    });

  }, [mode, authState, userId, fetchData, setRcaBookStatus]);

  useEffect(() => {
    if (mode === "update") {
      const config = { 
        url: `/rca/getforupdate`, 
        method: "post", 
        headers: { Authorization: authState.token },
        data: {rcaId: rcaId} 
      };

      fetchData(config, { showSuccessToast: false })
      .then((data) => {
        // console.log("response for update",data);
        setRca(data.userrca);
        // console.log("response for data.userrca.userRCAID",data.userrca.userRCAID);

        setFormData({
          userRCAID: data.userrca.userRCAID,   
          rcaType: data.userrca.rcaType, 
          rcaFor: data.userrca.rcaFor,   // Self, Team etc
          category: data.userrca.category,
          subCategory: data.userrca.subCategory,
          concernArea: data.userrca.concernArea,
          problemStatement: data.userrca.problemStatement,
          why1: data.userrca.why1,
          why2: data.userrca.why2,
          why3: data.userrca.why3,
          why4: data.userrca.why4,
          why5: data.userrca.why5,
          rootCause: data.userrca.rootCause,
          tags: data.userrca.tags,
          summary: data.userrca.summary,
          remarks: data.userrca.remarks,
          hasStatementAddOn: data.userrca.hasStatementAddOn,
          hasWhy1AddOn: data.userrca.hasWhy1AddOn,
          hasWhy2AddOn: data.userrca.hasWhy2AddOn,
          hasWhy3AddOn: data.userrca.hasWhy3AddOn,
          hasWhy4AddOn: data.userrca.hasWhy4AddOn,
          hasWhy5AddOn: data.userrca.hasWhy5AddOn,
          hasRootCauseAddOn: data.userrca.hasRootCauseAddOn,
          hasSolutionAddOn: data.userrca.hasSolutionAddOn,
          hasActionsAddOn: data.userrca.hasActionsAddOn,
          hasBeforeAfterAddOn: data.userrca.hasBeforeAfterAddOn,
          isApproved: data.userrca.isApproved,
          isFinal: data.userrca.isFinal,
          dateCreated: data.userrca.dateCreated,
          dateUpdated: data.userrca.dateUpdated,
          isActive: data.userrca.isActive,
          isDeleted: data.userrca.isDeleted,
          rcaCode: data.userrca.rcaCode,
          isPublic: data.userrca.isPublic,
          isShared: data.userrca.isShared,
          pairCode: data.userrca.pairCode,
          teamCode: data.userrca.teamCode,
          teamName: data.userrca.teanName,
          taskCode: data.userrca.taskCode,
          taskLinkDate: data.userrca.taskLinkDate,
          linkedRCACode: data.userrca.linkedRCACode,  
          quickSolutionsNote: data.userrca.quickSolutionsNote,
          quickSolutionsSelectionNote: data.userrca.quickSolutionsSelectionNote,
          quickSolutionsActionsNote: data.userrca.quickSolutionsActionsNote,
          quickImpactNotes: data.userrca.quickImpactNotes,

          isSheetal: data.userrca.isSheetal,
          ownerCode: data.userrca.ownerCode,
          ownerName: data.userrca.ownerName,
          masterOwnerCode: data.userrca.masterOwnerCode,
          masterOwnerName: data.userrca.masterOwnerName,
          department: data.userrca.department,
          subDepartment: data.userrca.subDepartment,
          region: data.userrca.region,
          district: data.userrca.district,    
          subDistrict: data.userrca.subDistrict,
          block: data.userrca.block,
          village: data.userrca.village,    
          state: data.userrca.state,   
          country: data.userrca.country, 
          isCompleted: data.userrca.isCompleted,
          completionDate: data.userrca.completionDate,
          isRecurring: data.userrca.isRecurring,
          isPriority: data.userrca.isPriority,
          sheetalRemarks: data.userrca.sheetalRemarks,
          status: data.userrca.status,

          isInspire: data.userrca.isInspire,
          student: data.userrca.student,
          school: data.userrca.school,
          session: data.userrca.session,
          studentClass: data.userrca.studentClass,
          section: data.userrca.section,
          teacher: data.userrca.teacher,
          principal: data.userrca.principal,
          admin: data.userrca.admin,
          inspireRemarks: data.userrca.inspireRemarks,

          isFinwiser: data.userrca.isFinwiser,
          branch:data.userrca.branch,
          subBranch: data.userrca.subBranch,
          manager: data.userrca.manager,
          employee: data.userrca.employee,
          customer: data.userrca.customer,
          consultant: data.userrca.consultant,
          partner: data.userrca.partner,
          finwiserRemarks: data.userrca.finwiserRemarks,

          isSports: data.userrca.isSports,
          coach: data.userrca.coach,
          assistantCoach: data.userrca.assistantCoach,
          player: data.userrca.player,
          ground: data.userrca.ground,
          tournament: data.userrca.tournament,
          sportsRemarks: data.userrca.sportsRemarks,

          isHealth: data.userrca.isHealth,
          patient: data.userrca.patient,
          doctor: data.userrca.doctor,
          hospital: data.userrca.hospital,
          headDoctor: data.userrca.headDoctor,
          speciality: data.userrca.speciality,
          healthRemarks: data.userrca.healthRemarks,

          isAgri: data.userrca.isAgri,
          farmer: data.userrca.farmer,
          helper: data.userrca.helper,
          supervisor: data.userrca.supervisor,
          manager: data.userrca.manager,
          crop: data.userrca.crop,
          area: data.userrca.area,
          agriRemarks: data.userrca.agriRemarks,
          
          assistant: data.userrca.assistant,
          supervisor: data.userrca.supervisor,

          rcaFromDate: data.userrca.rcaFromDate,
          rcaToDate: data.userrca.rcaToDate,

          rcaGroupCode: data.userrca.rcaGroupCode,
        });
        if(data.userrca.quickSolutionsNote != '')
        {
          setShowSolutionNotes(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching RCA data:", error);
        setError("Error fetching RCA data");
      });
    }
  }, [mode, authState, rcaId, fetchData, setRca]);


  const handleChange = e => {
    setFormData({
      ...formData, [e.target.name]: e.target.value
    });
  }

  const handleSubmit = e => {
    e.preventDefault();
    const errors = validateForm(formData);
    // console.log("error : ",errors," no. of error",Object.keys(errors).length);
    setFormErrors(errors);
    setCountFormErrors(Object.keys(errors).length);
    // console.log("setFormErrors : ",setFormErrors);

    if (Object.keys(errors).length > 0) {
      setFormErrors(
        Object.keys(errors).reduce((total, key) => {
          total[key] = errors[key];
          return total;
        }, {})
      );
      return;
    }

    // console.log("selectedrcaType ",formData.rcaType)
    const selectedrcaType=formData.rcaType;
    let destination='/my-concerns-list';
    const navigateBasedOnrcaType = (selectedrcaType) => {
      switch (selectedrcaType) {
        case 'Challenge':
          destination="/my-concerns-list";
          break;
        case 'Incident':
          destination="/my-concerns-list";
          break;
        case 'Issue':
          destination="/my-concerns-list";
          break;
        case 'Problem':
          destination="/my-concerns-list";
          break;
        case 'Goal':
          destination="/my-objectives-list";
          break;
        case 'Decision':
          destination="/my-objectives-list";
          break;
        default:
          destination="/my-concerns-list";
          break;
      }
      return destination;
    };

    if (mode === "add") {
      const config = { 
        url: "/rca", 
        method: "post", 
        data: {formData: formData, user: authState.user._id}, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting Data for "+mode+" RCA",config);
      fetchData(config).then(() => {
        const selectedrcaType = formData.rcaType;
        const destination = navigateBasedOnrcaType(selectedrcaType);
        // console.log("destination: "+destination);
        navigate(destination);
      });
    }
    else {
      const config = { 
        url: `/rca/${rcaId}`, 
        method: "put", 
        data: formData, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting Data for "+mode+" RCA",config);

      fetchData(config).then(() => {
        const selectedrcaType = formData.rcaType;
        const destination = navigateBasedOnrcaType(selectedrcaType);
        navigate(destination);
      })
      .catch((error) => {
        console.error("Error updating RCA:", error);
        setError("Error updating RCA");
      });
    }
  }

  const validateForm = formData => {
    const errors = {};
    if (!formData.rcaType) {
      errors.rcaType = "Please select a purpose";
    }
    if (!formData.category) {
      errors.category = "Category is required";
    } else if (formData.category.length > 50) {
      errors.category = "Cetegory cannot exceed 50 characters";
    }
    if (formData.subCategory.length > 50) {
      errors.subCategory = "Sub-cetegory cannot exceed 50 characters";
    }
    if (!formData.concernArea) {
      errors.concernArea = "Conern Area/Goal Title is required";
    } else if (formData.concernArea.length > 100) {
      errors.concernArea = "Conern Area/Goal Title cannot exceed 100 characters";
    }
    if (formData.problemStatement.length > 1000) {
      errors.problemStatement = "Statement cannot exceed 1000 characters";
    }
    if (formData.why1.length > 1000) {
      errors.why1 = "Why1 cannot exceed 1000 characters";
    }
    if (formData.why2.length > 1000) {
      errors.why2 = "Why2 cannot exceed 1000 characters";
    }
    if (formData.why3.length > 1000) {
      errors.why3 = "Why3 cannot exceed 1000 characters";
    }
    if (formData.why4.length > 1000) {
      errors.why4 = "Why4 cannot exceed 1000 characters";
    }
    if (formData.why5.length > 1000) {
      errors.why5 = "Why5 cannot exceed 1000 characters";
    }
    if (formData.rootCause.length > 1000) {
      errors.rootCause = "Root Casue Statement cannot exceed 2000 characters";
    }
    if (formData.tags.length > 100) {
      errors.tags = "Tags cannot exceed 100 characters";
    }
    if (formData.summary.length > 1000) {
      errors.summary = "Summary cannot exceed 1000 characters";
    }
    if (formData.remarks.length > 1000) {
      errors.remarks = "Remarks cannot exceed 1000 characters";
    }
    return errors;
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )

  const handleNavigateToExtension = () => {
    navigate("/rca-extension-form", 
      {state: 
        {
          rcaId: rcaId, 
          formData: formData, 
          concernArea: formData.concernArea, 
          rcaCode: formData.rcaCode
      }});
  };

  const handleNavigateToExampleDB = () => {
    navigate("/think5whys-db-list"); 
  }

  const handleNavigateToExtensionExample = () => {
    navigate("/think5whys-extension-example"); 
  }

  const handleNavigateToCounsellor = () => {
    navigate("/think5whys-counsellors"); 
  }

  const handleNavigateToConsultant = () => {
    navigate("/think5whys-consultants"); 
  }

  const [activeTab, setActiveTab] = useState('Init'); // Default tab
  const tabs = [
    { id: 'isInitTab', label: 'Init', icon: faLightbulb },          // Idea / Initialization
    { id: 'isRCATab', label: 'RCA', icon: faTools },                // Root Cause Analysis
    { id: 'isOthersTab', label: 'Others', icon: faLayerGroup },     // Miscellaneous
    { id: 'isSolutionTab', label: 'Solution', icon: faPuzzlePiece },// Problem-Solving
    { id: 'isSheetalTab', label: 'SHEETAL', icon: faClipboardList },// Sheetal Program / Organized
    { id: 'isInspireTab', label: 'INSPIRE', icon: faRocket },       // Innovation / Inspiration
    { id: 'isFinwiserTab', label: 'Finwiser', icon: faPiggyBank },  // Finance & Wisdom
    { id: 'isFocusTab', label: 'FOCUS', icon: faBullseye },         // Focus & Productivity
    { id: 'isHealthier', label: 'HEALTHIER', icon: faHeartbeat },   // Health & Wellness
    { id: 'isVardhini', label: 'Vardhini', icon: faLeaf },          // Growth / Sustainability
    { id: 'isPreferenceTab', label: 'Preference', icon: faSlidersH }, // Settings / Preferences
    { id: 'isExamples', label: 'Examples', icon: faBook },          // Learning / Examples
    { id: 'isExtension', label: 'Extension', icon: faPlusCircle }, // Add-ons / Extensions
    { id: 'isServicesTab', label: 'Services', icon: faHandsHelping }, // Services & Assistance
    { id: 'isUsingRCATab', label: 'Help', icon: faQuestionCircle }, // Help / Support
    { id: 'isNeedOfRCATab', label: 'Need of RCA', icon: faExclamationCircle } // Importance of RCA
  ];

  return (
    <div>
      <div className="bg-black mt-1">
        <h3 className="text-xl lg:text-2xl font-bold text-yellow-200 text-center">5 Why Analysis</h3>
        {loading ? (
          <Loader />
        ) : (
          <div className="text-sm">
            <div className="mx-auto p-4">
              <div className="text-center mb-2">
                <h2 className="text-lg font-semibold text-yellow-200">
                  {mode === "add" ? "Add New RCA" : "Edit RCA"}
                </h2>
              </div>

              <div className="flex flex-wrap justify-start gap-2 bg-black border border-yellow-500 p-0 rounded-md shadow-lg py-2 px-2">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    className={`flex-1 ml-1 min-w-[150px] px-2 py-2 rounded-md text-sm font-semibold transition ${
                      activeTab === tab.label
                        ? "bg-blue-500 text-white shadow"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-300"
                    }`}
                    onClick={() => setActiveTab(tab.label)}
                  >
                    <FontAwesomeIcon icon={tab.icon} className="text-lg mr-2" />
                    {tab.label}
                  </button>
                ))}
              </div>

              <div className="mt-2 mb-2 p-2 border rounded-md shadow-sm text-yellow-200 bg-blue-800 text-m">
                {activeTab === "Init" && <div>Input fields for Initial Setup</div>}
                {activeTab === "RCA" && <div>Input fields for RCA (Root Cause Analysis)</div>}
                {activeTab === "Others" && <div>Input fields for Other Information like Sharing, Team, Linked Task & Linked RCA</div>}
                {activeTab === "Solution" && <div>Input fields for Quick Solution</div>}
                {activeTab === "SHEETAL" && <div>Input fields for SHEETAL - Systematic Holistic Efficiency Enhancement for Transparent Administration Leadership</div>}
                {activeTab === "INSPIRE" && <div>Input fields for INSPIRE - Innovative System for Progressive Institutional Reform and Excellence</div>}
                {activeTab === "Finwiser" && <div>Input fields for Finwiser - Financial Innovation through Why-Driven Efficiency and Reform</div>}
                {activeTab === "FOCUS" && <div>Input fields for FOCUS - Functional Optimization for Coaching, Understanding and Success (Sports, Fitness, Wellness) Program</div>}
                {activeTab === "HEALTHIER" && <div>Input fields for HEALTHIER - Holistic Efficiency for Achieving Long-Term Health & Enhanced Results Program</div>}
                {activeTab === "Vardhini" && <div>Input fields for Vardhini - "वर्धिनी" (Vardhini) - "Growth Enhancer," symbolizing agricultural growth through problem-solving.</div>}
                {activeTab === "Preference" && <div>Preference for AI Support & Voice Input Enablement in Input Fields</div>}
                {activeTab === "Examples" && <div>View Examples on How To Do RCA</div>}
                {activeTab === "Extension" && <div>Input Extensive Study</div>}
                {activeTab === "Services" && <div>Contact Personal Counsellor or Business Consultant for Professional RCA Services</div>}
                {activeTab === "Help" && <div>Using Think5Whys RCA Input Form</div>}
                {activeTab === "Need of RCA" && <div>Why RCA?</div>}
              </div>

              {activeTab === "Preference" && (
                <div className="min-h-[35vh] border rounded-lg p-4 shadow-md bg-gray-800 mt-2">
                  <div className="mb-4 flex items-center">
                      <input
                        className="mr-2"
                        type="checkbox"
                        checked={isCheckedAISupport}
                        onChange={(e) => setIsCheckedAISupport(!isCheckedAISupport)}
                      />
                      <span className="text-sm text-white">
                        I want Gen AI Support to generate AI Prompt or getting a response from ChatGPT as Think5Whys AI partner.
                      </span>
                    </div>

                    <div className="mb-4 flex items-center">
                      <input
                        className="mr-2"
                        type="checkbox"
                        checked={showMicrophoneAlert}
                        onChange={(e) => setShowMicrophoneAlert(!showMicrophoneAlert)}
                      />
                      <span className="text-sm text-white">
                        I want to enable Voice Input (Best supported in Chrome browser)
                      </span>
                    </div>
                  </div>
              )}

              { activeTab === "Init" && (  
                <div className="border rounded-lg p-4 shadow-md bg-gray-800">
                  <div className="border rounded-lg p-4 shadow-md bg-gray-800">
                      <p className="text-white text-sm">Think5Whys Main BOK Status: {rcaBookStatus ? "Purchased": "Not Purchased Yet"}</p>
                      <p className="text-yellow-300 text-sm">Think5Whys RCA Code: {autoRCACode}</p>
                  </div> 
                  <div className='mt-4'>
                    <div className="text-sm">
                      <p className='text-white'>RCA Purpose*</p>
                      <select name="rcaType" id="rcaType" value={formData.rcaType}
                        onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', height: 'auto', minHeight: '40px' }}>
                        <option value="">Select RCA Type</option>
                        <option value="Challenge">Challenge</option>
                        <option value="Incident">Incident</option>
                        <option value="Issue">Issue</option>
                        <option value="Problem">Problem</option>
                        <option value="Goal">Goal</option>
                        <option value="Decision">Decision</option>
                      </select>
                      {fieldError("rcaType")}
                    </div>
                    <div className="text-sm">
                      <p className='text-white'>RCA For*</p>
                      <select name="rcaFor" id="rcaFor" value={formData.rcaFor}
                        onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', height: 'auto', minHeight: '40px' }}>
                        <option value="">Select RCA For</option>
                        <option value="Personal-Self">Personal-Self</option>
                        <option value="Personal-Job">Personal-Job</option>                    
                        <option value="Client">Client</option>
                        <option value="Team">Team</option>
                        <option value="Project">Project</option>
                        <option value="Process">Process</option>
                        <option value="Department">Department</option>
                        <option value="Location">Location</option>
                        <option value="Company">Company</option>
                        <option value="Family">Family</option>
                        <option value="Government">Government</option>
                        <option value="Entity">Entity</option>
                        <option value="Machine">Machine</option>
                        <option value="Factory">Factory</option>
                        <option value="Material">Material</option>
                        <option value="Society">Society</option>
                        <option value="Research & Study">Research & Study</option>
                        <option value="Personal-Hobby">Personal-Hobby</option>
                      </select>
                      {fieldError("rcaFor")}
                    </div>
                    <div className="mb-2 text-sm">
                      <p className='text-white'>Category*</p>
                      <input
                        type="text"
                        name="category"
                        id="category"
                        value={formData.category}
                        placeholder="Input Category Name"
                        onChange={handleChange}
                        className="border-inputbox"
                        style={{ border: '1px solid #ccc', padding: '8px', width:'300px', height: 'auto', minHeight: '40px' }}
                      />
                      {fieldError("category")}
                    </div>
                    <div className="mb-2 text-sm">
                      <p className='text-white'>Sub-Category</p>
                      <input
                        type="text"
                        name="subCategory"
                        id="subCategory"
                        value={formData.subCategory}
                        placeholder="Input Sub-Category Name"
                        onChange={handleChange}
                        className="border-inputbox"
                        style={{ border: '1px solid #ccc', padding: '8px', width:'300px', height: 'auto', minHeight: '40px' }}
                      />
                      {fieldError("subCategory")}
                    </div>
                    <div className="mb-2 text-sm">
                      <p className='text-white'>Area of Concern / Goal*</p>
                      <input
                        type="concernArea"
                        name="concernArea"
                        id="concernArea"
                        value={formData.concernArea}
                        maxLength="500"
                        placeholder="Input Concern / Goal"
                        onChange={handleChange}
                        style={{ 
                          border: '1px solid #ccc', 
                          padding: '8px', 
                          height: 'auto', 
                          width: '100%',
                          minHeight: '40px' 
                        }}
                      />
                      {fieldError("concernArea")}
                    </div>
                    <div className="flex flex-col mr-12">
                      <label className="text-sm font-semibold text-white mb-1">From Date:</label>
                      <DatePicker
                        selected={formData.rcaFromDate}
                        onChange={(date) => setFormData({ ...formData, rcaFromDate: date })}
                        className="text-sm w-80 text-black p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        // style={{width: "250px"}}                    
                        dateFormat="dd-MM-yyyy"
                      />
                    </div>

                    <div className="flex flex-col">
                      <label className="text-sm font-semibold text-white mb-1">To Date:</label>
                      <DatePicker
                        selected={formData.rcaToDate}
                        onChange={(date) => setFormData({ ...formData, rcaToDate: date })}
                        className="text-sm w-80 text-black p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        // style={{width: "250px"}}
                        dateFormat="dd-MM-yyyy"
                      />
                    </div>
                  </div>
                </div>
              )}

              { activeTab === "RCA" && ( 
                <div className="border rounded-lg p-4 shadow-md bg-gray-800">
                  <div className="border rounded-lg p-4 shadow-md bg-gray-800">
                    <div className="mb-2 text-sm">
                      <p className='text-white'>Problem Statement*</p>
                      { showMicrophoneAlert ? (
                        <SpeechInputComponent
                          label="Problem Statement"
                          name="problemStatement"
                          value={formData.problemStatement}
                          onChange={handleChange}
                          placeholder="Click Mic for Voice Input..."
                          maxLength="1000"
                        />
                      ) : (
                        <textarea
                          label="Problem Statement"
                          name="problemStatement"
                          value={formData.problemStatement}
                          onChange={handleChange}
                          placeholder="Write here for Input..."
                          maxLength="1000"
                          style={{
                            border: '1px solid #ccc',
                            padding: '2px',
                            backgroundColor: '#f0f0f0', 
                            color: '#000000',
                            maxWidth: '100%', 
                            maxHeight: '150px' 
                          }}
                        />
                      )}
                      {fieldError("problemStatement")}
                      {isCheckedAISupport && formData.problemStatement!== '' && (
                      <div className="mb-1">
                        <AILightComponent param1={"Problem Statement"} param2={formData.problemStatement}/>
                      </div>
                      )}
                    </div>
                  </div>
                  <div className="border rounded-lg p-4 shadow-md bg-gray-800">
                    <div className="text-sm">
                      <p className='text-white'>Why1</p>
                      { showMicrophoneAlert ? (
                        <SpeechInputComponent
                          label="Why1"
                          name="why1"
                          value={formData.why1}
                          onChange={handleChange}
                          placeholder="Write here or Click Mic for Voice Input..."
                          maxLength="1000"
                        />
                      ) : (
                        <textarea
                          label="Why1"
                          name="why1"
                          value={formData.why1}
                          onChange={handleChange}
                          placeholder="Write here for Input..."
                          maxLength="1000"
                          style={{
                            border: '1px solid #ccc',
                            padding: '2px',
                            backgroundColor: '#f0f0f0', 
                            color: '#000000',
                            maxWidth: '100%', 
                            maxHeight: '150px' 
                          }}
                        />
                      )}
                      {fieldError("why1")}
                      {isCheckedAISupport && formData.why1!== '' && (
                      <div className="mb-1">
                        <AILightComponent param1={"Why 1"} param2={formData.why1}/>
                      </div>
                      )}
                    </div>
                    <div className="text-sm">
                      <p className='text-white'>Why2</p>
                      { showMicrophoneAlert ? (
                        <SpeechInputComponent
                          label="Why2"
                          name="why2"
                          value={formData.why2}
                          onChange={handleChange}
                          placeholder="Write here or Click Mic for Voice Input..."
                          maxLength="1000"
                        />
                      ) : (
                        <textarea
                          label="Why2"
                          name="why2"
                          value={formData.why2}
                          onChange={handleChange}
                          placeholder="Write here for Input..."
                          maxLength="1000"
                          style={{
                            border: '1px solid #ccc',
                            padding: '2px',
                            backgroundColor: '#f0f0f0', 
                            color: '#000000',
                            maxWidth: '100%', 
                            maxHeight: '150px' 
                          }}
                        />
                      )}
                      {fieldError("why2")}
                      {isCheckedAISupport && formData.why2!== '' && (
                      <div className="mb-1">
                        <AILightComponent param1={"Why 2"} param2={formData.why2}/>
                      </div>
                      )}
                    </div>
                    <div className="text-sm">
                      <p className='text-white'>Why3</p>
                      { showMicrophoneAlert ? (
                        <SpeechInputComponent
                          label="Why3"
                          name="why3"
                          value={formData.why3}
                          onChange={handleChange}
                          placeholder="Write here or Click Mic for Voice Input..."
                          maxLength="1000"
                        />
                      ) : (
                        <textarea
                          label="Why3"
                          name="why3"
                          value={formData.why3}
                          onChange={handleChange}
                          placeholder="Write here for Input..."
                          maxLength="1000"
                          style={{
                            border: '1px solid #ccc',
                            padding: '2px',
                            backgroundColor: '#f0f0f0', 
                            color: '#000000',
                            maxWidth: '100%', 
                            maxHeight: '150px' 
                          }}
                        />
                      )}
                      {fieldError("why3")}
                      {isCheckedAISupport && formData.why3!== '' && (
                      <div className="mb-1">
                      <AILightComponent param1={"Why 3"} param2={formData.why3}/>
                      </div>
                      )}
                    </div>
                    <div className="text-sm">
                      <p className='text-white'>Why4</p>
                      { showMicrophoneAlert ? (
                        <SpeechInputComponent
                          label="Why4"
                          name="why4"
                          value={formData.why4}
                          onChange={handleChange}
                          placeholder="Write here or Click Mic for Voice Input..."
                          maxLength="1000"
                        />
                      ) : (
                        <textarea
                          label="Why4"
                          name="why4"
                          value={formData.why4}
                          onChange={handleChange}
                          placeholder="Write here for Input..."
                          maxLength="1000"
                          style={{
                            border: '1px solid #ccc',
                            padding: '2px',
                            backgroundColor: '#f0f0f0', 
                            color: '#000000',
                            maxWidth: '100%', 
                            maxHeight: '150px' 
                          }}
                        />
                      )}
                      {fieldError("why4")}
                      {isCheckedAISupport && formData.why4!== '' && (
                      <div className="mb-1">
                      <AILightComponent param1={"Why 4"} param2={formData.why4}/>
                      </div>
                      )}
                    </div>
                    <div className="text-sm">
                      <p className='text-white'>Why5</p>
                      { showMicrophoneAlert ? (
                        <SpeechInputComponent
                          label="Why5"
                          name="why5"
                          value={formData.why5}
                          onChange={handleChange}
                          placeholder="Write here or Click Mic for Voice Input..."
                          maxLength="1000"
                        />
                      ) : (
                        <textarea
                          label="Why5"
                          name="why5"
                          value={formData.why5}
                          onChange={handleChange}
                          placeholder="Write here for Input..."
                          maxLength="1000"
                          style={{
                            border: '1px solid #ccc',
                            padding: '2px',
                            backgroundColor: '#f0f0f0', 
                            color: '#000000',
                            maxWidth: '100%', 
                            maxHeight: '150px' 
                          }}
                        />
                      )}
                      {fieldError("why5")}
                      {isCheckedAISupport && formData.why5!== '' && (
                      <div className="mb-1">
                        <AILightComponent param1={"Why 5"} param2={formData.why5}/>
                      </div>
                      )}
                    </div>
                  </div>
                  <div className="border rounded-lg p-4 shadow-md bg-gray-800">
                      <div className="text-sm">
                        <p className='text-white'>Root Cause</p>
                        {showMicrophoneAlert ? (
                          <SpeechInputComponent
                            label="Root Cause"
                            name="rootCause"
                            value={formData.rootCause}
                            onChange={handleChange}
                            placeholder="Write here or Click Mic for Voice Input..."
                            maxLength="1000"
                          />
                        ) : (
                          <textarea
                            label="Root Cause"
                            name="rootCause"
                            value={formData.rootCause}
                            onChange={handleChange}
                            placeholder="Write here for Input..."
                            maxLength="1000"
                            style={{
                              border: '1px solid #ccc',
                              padding: '2px',
                              backgroundColor: '#f0f0f0', 
                              color: '#000000',
                              maxWidth: '100%', 
                              maxHeight: '150px' 
                            }}
                          />
                        )}
                        {fieldError("rootCause")}
                        {isCheckedAISupport && formData.rootCause!== '' && (
                          <div className="mb-1">
                            <AILightComponent param1={"Root Cause"} param2={formData.rootCause}/>
                          </div>
                        )}
                      </div>
                    </div>
                </div>
              )}

              { activeTab === "Others" && (   
                <>
                  <div className="border rounded-lg p-4 shadow-md bg-gray-800">
                      <div className="mb-4">
                        <p className="block text-sm text-white mb-2">
                          Your Own RCA# (If Any):
                        </p>
                        <input
                          type="text"
                          name="userRCAID"
                          id="userRCAID"
                          value={formData.userRCAID}
                          placeholder="Input Your RCA Code"
                          maxLength="15"
                          onChange={handleChange}
                          className="w-full px-3 py-2 border border-gray-400 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        {fieldError("userRCAID")}
                      </div>
                      <div className="flex flex-col justify-start">
                        <p className='text-white'>Problem Keywords / Search Tags (Comma , separated):</p>
                        {showMicrophoneAlert ? (
                          <SpeechInputComponent
                            label="Keywords"
                            name="tags"
                            value={formData.tags}
                            onChange={handleChange}
                            placeholder="Write here or Click Mic for Voice Input..."
                            maxLength="1000"
                          />
                        ) : (
                          <textarea
                            label="Keywords"
                            name="tags"
                            value={formData.tags}
                            onChange={handleChange}
                            placeholder="Write here for Input..."
                            maxLength="1000"
                            style={{
                              border: '1px solid #ccc',
                              padding: '2px',
                              backgroundColor: '#f0f0f0', 
                              color: '#000000',
                              maxWidth: '100%', 
                              maxHeight: '150px' 
                            }}
                          />
                        )}
                        {fieldError("tags")}
                        { isCheckedAISupport && formData.problemStatement!== '' && formData.why1!== '' && 
                          formData.why2!== '' && formData.why3!== '' && formData.why4!== '' && formData.why5!== '' && 
                          (
                            <div className="mt-4">
                                <AILightComponent param1={"Overall Summary"} param2={formData.tags}/>
                            </div>
                        )}
                      </div>
                    </div>
                    <div className="border rounded-lg p-4 shadow-md bg-gray-800">
                      <label>
                        <input className='mr-4' type="checkbox" checked={formData.isPublic} onChange={(e) => setFormData({ ...formData, isPublic: e.target.checked })} />
                        Make Visble to Public?
                      </label>
                    </div>
                    <div className="border rounded-lg p-4 shadow-md bg-gray-800">
                      <div className='mb-2'>  
                        <label>
                          <input className='mr-4' type="checkbox" checked={formData.isShared} onChange={(e) => setFormData({ ...formData, isShared: e.target.checked })} />
                          Is Shared?
                        </label>
                      </div>    
                      { formData.isShared && ( 
                        <> 
                          <div className="flex flex-col justify-center text-white">
                            <p>Pair:</p>
                            <input
                              type="text"
                              className="profile-input text-black"
                              style={{ maxWidth: '150px', height: '34px', lineHeight: '24px' }}
                              value={formData.pairCode}
                              onChange={(e) => setFormData({ ...formData, pairCode: e.target.value })}
                              placeholder="Enter pair code"
                            />
                          </div>
                          <div className="flex flex-col justify-center text-white mt-2">
                            <p>Team:</p>
                            <input
                              type="text"
                              className="profile-input text-black"
                              style={{ maxWidth: '150px', height: '34px', lineHeight: '24px' }}
                              value={formData.teamCode}
                              onChange={(e) => setFormData({ ...formData, teamCode: e.target.value })}
                              placeholder="Enter team code"
                            />
                            <input
                              type="text"
                              className="mt-2 profile-input text-black"
                              style={{ maxWidth: '80%', width: '300px', height: '34px', lineHeight: '24px' }}
                              value={formData.teamName}
                              onChange={(e) => setFormData({ ...formData, teamName: e.target.value })}
                              placeholder="Enter team name"
                            />
                          </div>
                        </>
                      )}
                    </div>
                    <div className="border rounded-lg p-4 shadow-md bg-gray-800">
                      <div className="flex flex-col justify-center text-white">
                        <p>Linked Task Code:</p>
                        <input
                          type="text"
                          className="profile-input text-black"
                          style={{ maxWidth: '150px', height: '34px', lineHeight: '24px' }}
                          value={formData.taskCode}
                          onChange={(e) => setFormData({ ...formData, taskCode: e.target.value })}
                          placeholder="Enter Task Code"
                        />
                      </div>
                    {/* </div>
                    <div className="border rounded-lg p-4 shadow-md bg-gray-800"> */}
                      <p className='text-sm mt-1 text-white'>Linked RCA:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ width: '175px', height: '34px', lineHeight: '24px' }}

                        value={formData.linkedRCACode}
                        onChange={(e) => setFormData({ ...formData, linkedRCACode: e.target.value })}
                        placeholder="Enter RCA Linking Code"
                      />
                      <p className='text-sm mt-1 text-white'>Own RCA Group Code (for AI Counselling Pull Data etc):</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ width: '175px', height: '34px', lineHeight: '24px' }}

                        value={formData.rcaGroupCode}
                        onChange={(e) => setFormData({ ...formData, rcaGroupCode: e.target.value })}
                        placeholder="Enter RCA Group Code"
                      />
                    </div>
                    <div className="border rounded-lg p-4 shadow-md bg-gray-800">
                      <div className="flex flex-col justify-start">
                        <p className='text-white'>Overall Summary:</p>
                        {showMicrophoneAlert ? (
                          <SpeechInputComponent
                            label="Summary"
                            name="summary"
                            value={formData.summary}
                            onChange={handleChange}
                            placeholder="Write here or Click Mic for Voice Input..."
                            maxLength="1000"
                          />
                        ) : (
                          <textarea
                            label="Summary"
                            name="summary"
                            value={formData.summary}
                            onChange={handleChange}
                            placeholder="Write here for Input..."
                            maxLength="1000"
                            style={{
                              border: '1px solid #ccc',
                              padding: '2px',
                              backgroundColor: '#f0f0f0', 
                              color: '#000000',
                              maxWidth: '100%', 
                              maxHeight: '150px' 
                            }}
                          />
                        )}
                        {fieldError("summary")}
                        { isCheckedAISupport && formData.summary!== '' && formData.why1!== '' && 
                          formData.why2!== '' && formData.why3!== '' && formData.why4!== '' && formData.why5!== '' && 
                          (
                            <div className="mt-4">
                                <AILightComponent param1={"Overall Summary"} param2={formData.summary}/>
                            </div>
                        )}
                      </div>
                    </div>
                    <div className="border rounded-lg p-4 shadow-md bg-gray-800">
                      <div className="flex flex-col justify-center text-white mt-2">
                        <p>Think5Whys Assistant:</p>
                        <input
                          type="text"
                          className="profile-input text-black"
                          style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                          value={formData.assistant}
                          onChange={(e) => setFormData({ ...formData, assistant: e.target.value })}
                          placeholder="Enter Assistant Code"
                        />
                      </div>
                      <div className="flex flex-col justify-center text-white mt-2">
                        <p>Think5Whys Supervisor:</p>
                        <input
                          type="text"
                          className="profile-input text-black"
                          style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                          value={formData.supervisor}
                          onChange={(e) => setFormData({ ...formData, supervisor: e.target.value })}
                          placeholder="Enter Supervisor Code"
                        />
                      </div>
                    </div>
                </>
              )}

              { activeTab === "Solution" && (    
                <>
                <div className="border-container bg-black border-blue-800">
                  <div className="text-sm">
                    <p className='text-white'>Solution Suggestion List</p>
                    {showMicrophoneAlert ? (
                    <SpeechInputComponent
                      label="Solution Suggestion"
                      name="quickSolutionsNote"
                      value={formData.quickSolutionsNote}
                      onChange={handleChange}
                      placeholder="Write here or Click Mic for Voice Input..."
                      maxLength="1000"
                    />
                  ) : (
                    <textarea
                      label="Solution Suggestion"
                      name="quickSolutionsNote"
                      value={formData.quickSolutionsNote}
                      onChange={handleChange}
                      placeholder="Write here for Input..."
                      maxLength="1000"
                      style={{
                        border: '1px solid #ccc',
                        padding: '2px',
                        backgroundColor: '#f0f0f0', 
                        color: '#000000',
                        maxWidth: '100%', 
                        maxHeight: '150px' 
                      }}
                    />
                  )}
                    {fieldError("quickSolutionsNote")}
                    {isCheckedAISupport && formData.quickSolutionsNote!== '' && (
                      <div className="mb-1">
                        <AILightComponent param1={"Give Solution Suggestion List"} param2={formData.quickSolutionsNote}/>
                      </div>
                    )}
                  </div>
                  <div className="text-sm flex flex-col">
                    <p className='text-white'>Selected Solution form Suggested Solution List:</p>
                    <input
                      type="text"
                      name="quickSolutionsSelectionNote"
                      id="quickSolutionsSelectionNote"
                      value={formData.quickSolutionsSelectionNote}
                      placeholder="Write here.."
                      onChange={handleChange}
                      maxLength="2000"
                      style={{ border: '1px solid #ccc', padding: '8px', height: 'auto', minHeight: '40px' }}
                    />
                    {fieldError("quickSolutionsSelectionNote")}
                  </div>
                  <div className="text-sm mt-4">
                    <p className='text-white'>Quick Solution Actions Notes</p>
                      {showMicrophoneAlert ? (
                      <SpeechInputComponent
                        label="Quick Solution Actions Notes"
                        name="quickSolutionsActionsNote"
                        value={formData.quickSolutionsActionsNote}
                        onChange={handleChange}
                        placeholder="Write here or Click Mic for Voice Input..."
                        maxLength="2500"
                      />
                    ) : (
                      <textarea
                        label="Quick Solution Actions Notes"
                        name="quickSolutionsActionsNote"
                        value={formData.quickSolutionsActionsNote}
                        onChange={handleChange}
                        placeholder="Write here for Input..."
                        maxLength="2500"
                        style={{
                          border: '1px solid #ccc',
                          padding: '2px',
                          backgroundColor: '#f0f0f0', 
                          color: '#000000',
                          maxWidth: '100%', 
                          maxHeight: '350px' 
                        }}
                      />
                    )}
                    {fieldError("quickSolutionsActionsNote")}
                    {isCheckedAISupport && formData.quickSolutionsActionsNote!== '' && (
                      <div className="mb-1">
                        <AILightComponent param1={"Suggest Quick Solution Actions Notes"} param2={formData.quickSolutionsActionsNote}/>
                      </div>
                    )}
                  </div>
                  <div className="text-sm mt-4">
                    <p className='text-white'>Quick Note on Solution Actions Imapct:</p>
                      {showMicrophoneAlert ? (
                      <SpeechInputComponent
                        label="Quick Solution Actions Notes"
                        name="quickImpactNotes"
                        value={formData.quickImpactNotes}
                        onChange={handleChange}
                        placeholder="Write here or Click Mic for Voice Input..."
                        maxLength="2500"
                      />
                    ) : (
                      <textarea
                        label="Quick Notes on Solution Actions Impact"
                        name="quickImpactNotes"
                        value={formData.quickImpactNotes}
                        onChange={handleChange}
                        placeholder="Write here for Input..."
                        maxLength="2500"
                        style={{
                          border: '1px solid #ccc',
                          padding: '2px',
                          backgroundColor: '#f0f0f0', 
                          color: '#000000',
                          maxWidth: '100%', 
                          maxHeight: '350px' 
                        }}
                      />
                    )}
                    {fieldError("quickImpactNotes")}
                    {isCheckedAISupport && formData.quickImpactNotes!== '' && (
                      <div className="mb-1">
                        <AILightComponent param1={"Give Quick Notes on Solution Actions Impact"} param2={formData.quickImpactNotes}/>
                      </div>
                    )}
                  </div>
                </div>
                </>
              )}

              { activeTab === "SHEETAL" && (    
                <div className="border rounded-lg p-4 shadow-md bg-black border-green-400">  
                  <div className="mb-4 flex flex-col">
                    <label>
                      <input className='mr-4' type="checkbox" checked={formData.isSheetal} onChange={(e) => setFormData({ ...formData, isSheetal: e.target.checked })} />
                      For SHEETAL - Systematic Holistic Efficiency Enhancement for Transparent Administration Leadership?
                    </label>
                  </div>
                  <div className="flex flex-col justify-center text-white">
                      <p>Owner / Employee / Subordinate:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.ownerCode}
                        onChange={(e) => setFormData({ ...formData, ownerCode: e.target.value })}
                        placeholder="Enter Owner Id/Code"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Master Owner / Superior:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.masterOwnerCode}
                        onChange={(e) => setFormData({ ...formData, masterOwnerCode: e.target.value })}
                        placeholder="Enter Master Owner Id/Code"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white">
                      <p>Department:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.department}
                        onChange={(e) => setFormData({ ...formData, department: e.target.value })}
                        placeholder="Enter Department Name"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Sub-Department/Section:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.subDepartment}
                        onChange={(e) => setFormData({ ...formData, subDepartment: e.target.value })}
                        placeholder="Enter Sub-Department Name"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white">
                      <p>Region:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.region}
                        onChange={(e) => setFormData({ ...formData, region: e.target.value })}
                        placeholder="Enter Region Name"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>District:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.district}
                        onChange={(e) => setFormData({ ...formData, district: e.target.value })}
                        placeholder="Enter District"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white">
                      <p>Sub-District/Taluka/Tehsil/Sub-Division:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.subDistrict}
                        onChange={(e) => setFormData({ ...formData, subDistrict: e.target.value })}
                        placeholder="Enter Sub-District"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Block:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.block}
                        onChange={(e) => setFormData({ ...formData, block: e.target.value })}
                        placeholder="Enter Block Name"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white">
                      <p>Village/Urbanbody:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.village}
                        onChange={(e) => setFormData({ ...formData, village: e.target.value })}
                        placeholder="Enter Village/Urbanbody Name"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>State:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.state}
                        onChange={(e) => setFormData({ ...formData, state: e.target.value })}
                        placeholder="Enter State Name"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Country:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.country}
                        onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                      />
                    </div>
                    <div className='mb-2'>  
                      <label>
                        <input className='mr-4' type="checkbox" checked={formData.isCompleted} onChange={(e) => setFormData({ ...formData, isCompleted: e.target.checked })} />
                        Is Completed?
                      </label>
                      { formData.isSheetal && (
                        <div className="mb-2 text-sm">
                          <label htmlFor="enddate">Completion Date:</label>
                          <br />
                          <DatePicker
                            selected={formData.completionDate}
                            onChange={(date) => setFormData({ ...formData, completionDate: date })}
                            dateFormat="dd/MM/yyyy"
                            id="completionDate"
                            name="completionDate"
                            className="form-control h-8"
                          />
                          {fieldError("completionDate")}
                        </div>
                      )}
                    </div> 
                    <div className='mb-2'>  
                      <label>
                        <input className='mr-4' type="checkbox" checked={formData.isRecurring} onChange={(e) => setFormData({ ...formData, isRecurring: e.target.checked })} />
                        Is Recurring?
                      </label>
                    </div> 
                    <div className='mb-2'>  
                      <label>
                        <input className='mr-4' type="checkbox" checked={formData.isPriority} onChange={(e) => setFormData({ ...formData, isPriority: e.target.checked })} />
                        Is Priority?
                      </label>
                    </div> 
                    <div className="mb-2 text-sm">
                      <p className='text-white'>SHEETAL Remarks:</p>
                      { showMicrophoneAlert ? (
                        <SpeechInputComponent
                          label="SHEETAL Remarks"
                          name="sheetalRemarks"
                          value={formData.sheetalRemarks}
                          onChange={handleChange}
                          placeholder="Click Mic for Voice Input..."
                          maxLength="1000"
                        />
                      ) : (
                        <textarea
                          label="SHEETAL Remarks"
                          name="sheetalRemarks"
                          value={formData.sheetalRemarks}
                          onChange={handleChange}
                          placeholder="Write here for Input..."
                          maxLength="1000"
                          style={{
                            border: '1px solid #ccc',
                            padding: '2px',
                            backgroundColor: '#f0f0f0', 
                            color: '#000000',
                            maxWidth: '100%', 
                            maxHeight: '150px' 
                          }}
                        />
                      )}
                      {fieldError("sheetalRemarks")}
                      {isCheckedAISupport && formData.sheetalRemarks!== '' && (
                      <div className="mb-1">
                        <AILightComponent param1={"SHEETAL Remarks"} param2={formData.sheetalRemarks}/>
                      </div>
                      )}
                    </div>
                    <div className="flex flex-col justify-center text-white">
                      <p>Status:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.status}
                        onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                        placeholder="Enter Status"
                      />
                    </div>
                </div>
              )}

              { activeTab === "INSPIRE" && (    
                <div className="border rounded-lg p-4 shadow-md bg-black border-purple-400">  
                  <div className="mb-4 flex flex-col">
                    <label>
                      <input className='mr-4' type="checkbox" checked={formData.isInspire} onChange={(e) => setFormData({ ...formData, isInspire: e.target.checked })} />
                      For INSPIRE - Innovative System for Progressive Institutional Reform and Excellence?
                    </label>
                  </div>
                  <div className="flex flex-col justify-center text-white">
                      <p>Student:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.student}
                        onChange={(e) => setFormData({ ...formData, student: e.target.value })}
                        placeholder="Enter Student Code"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Teacher:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.teacher}
                        onChange={(e) => setFormData({ ...formData, teacher: e.target.value })}
                        placeholder="Enter Teacher Code"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Principal:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.principal}
                        onChange={(e) => setFormData({ ...formData, principal: e.target.value })}
                        placeholder="Enter Teacher Code"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Admin:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.admin}
                        onChange={(e) => setFormData({ ...formData, admin: e.target.value })}
                        placeholder="Enter Admin Code"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white">
                      <p>Academic Session:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.session}
                        onChange={(e) => setFormData({ ...formData, session: e.target.value })}
                        placeholder="Enter Session"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Class:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.studentClass}
                        onChange={(e) => setFormData({ ...formData, studentClass: e.target.value })}
                        placeholder="Enter Class/Grade"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Section:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.section}
                        onChange={(e) => setFormData({ ...formData, section: e.target.value })}
                        placeholder="Enter Section"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white">
                      <p>Branch:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.branch}
                        onChange={(e) => setFormData({ ...formData, branch: e.target.value })}
                        placeholder="Enter Branch/Location"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>State:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.state}
                        onChange={(e) => setFormData({ ...formData, state: e.target.value })}
                        placeholder="Enter State Name"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Country:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.country}
                        onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                      />
                    </div>
                    <div className='mb-2'>  
                      <label>
                        <input className='mr-4' type="checkbox" checked={formData.isCompleted} onChange={(e) => setFormData({ ...formData, isCompleted: e.target.checked })} />
                        Is Completed?
                      </label>
                      { formData.isInspire && (
                        <div className="mb-2 text-sm">
                          <label htmlFor="enddate">Completion Date:</label>
                          <br />
                          <DatePicker
                            selected={formData.completionDate}
                            onChange={(date) => setFormData({ ...formData, completionDate: date })}
                            dateFormat="dd/MM/yyyy"
                            id="completionDate"
                            name="completionDate"
                            className="form-control h-8"
                          />
                          {fieldError("completionDate")}
                        </div>
                      )}
                    </div> 
                    <div className='mb-2'>  
                      <label>
                        <input className='mr-4' type="checkbox" checked={formData.isRecurring} onChange={(e) => setFormData({ ...formData, isRecurring: e.target.checked })} />
                        Is Recurring?
                      </label>
                    </div> 
                    <div className='mb-2'>  
                      <label>
                        <input className='mr-4' type="checkbox" checked={formData.isPriority} onChange={(e) => setFormData({ ...formData, isPriority: e.target.checked })} />
                        Is Priority?
                      </label>
                    </div> 
                    <div className="mb-2 text-sm">
                      <p className='text-white'>INSPIRE Remarks:</p>
                      { showMicrophoneAlert ? (
                        <SpeechInputComponent
                          label="INSPIRE Remarks"
                          name="inspireRemarks"
                          value={formData.inspireRemarks}
                          onChange={handleChange}
                          placeholder="Click Mic for Voice Input..."
                          maxLength="1000"
                        />
                      ) : (
                        <textarea
                          label="INSPIRE Remarks"
                          name="inspireRemarks"
                          value={formData.inspireRemarks}
                          onChange={handleChange}
                          placeholder="Write here for Input..."
                          maxLength="1000"
                          style={{
                            border: '1px solid #ccc',
                            padding: '2px',
                            backgroundColor: '#f0f0f0', 
                            color: '#000000',
                            maxWidth: '100%', 
                            maxHeight: '150px' 
                          }}
                        />
                      )}
                      {fieldError("inspireRemarks")}
                      {isCheckedAISupport && formData.inspireRemarks!== '' && (
                      <div className="mb-1">
                        <AILightComponent param1={"INSPIRE Remarks"} param2={formData.inspireRemarks}/>
                      </div>
                      )}
                    </div>
                    <div className="flex flex-col justify-center text-white">
                      <p>Status:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.status}
                        onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                        placeholder="Enter Status"
                      />
                    </div>
                </div>
              )}

              { activeTab === "Finwiser" && (  
                <div className="border rounded-lg p-4 shadow-md bg-black border-blue-400">  
                  <div className="mb-4 flex flex-col">
                    <label>
                      <input className='mr-4' type="checkbox" checked={formData.isFinwiser} onChange={(e) => setFormData({ ...formData, isFinwiser: e.target.checked })} />
                      For Finwiser - Financial Innovation through Why-Driven Efficiency and Reform?
                    </label>
                  </div>
                  <div className="flex flex-col justify-center text-white">
                      <p>Employee:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.employee}
                        onChange={(e) => setFormData({ ...formData, employee: e.target.value })}
                        placeholder="Enter Employee Code"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Manager:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.manager}
                        onChange={(e) => setFormData({ ...formData, manager: e.target.value })}
                        placeholder="Enter Manager Code"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Client/Customer:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.customer}
                        onChange={(e) => setFormData({ ...formData, customer: e.target.value })}
                        placeholder="Enter Customer Id"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Partner:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.partner}
                        onChange={(e) => setFormData({ ...formData, partner: e.target.value })}
                        placeholder="Enter Partner Code"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Consultant:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.consultant}
                        onChange={(e) => setFormData({ ...formData, consultant: e.target.value })}
                        placeholder="Enter Consultant Code"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white">
                      <p>Branch Id/Code/Name:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.branch}
                        onChange={(e) => setFormData({ ...formData, branch: e.target.value })}
                        placeholder="Enter Branch"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Sub Branch Id/Code/Name:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.subBranch}
                        onChange={(e) => setFormData({ ...formData, subBranch: e.target.value })}
                        placeholder="Enter Sub-branch"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Department:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.department}
                        onChange={(e) => setFormData({ ...formData, department: e.target.value })}
                        placeholder="Enter Department"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>State:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.state}
                        onChange={(e) => setFormData({ ...formData, state: e.target.value })}
                        placeholder="Enter State Name"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Country:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.country}
                        onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                      />
                    </div>
                    <div className='mb-2'>  
                      <label>
                        <input className='mr-4' type="checkbox" checked={formData.isCompleted} onChange={(e) => setFormData({ ...formData, isCompleted: e.target.checked })} />
                        Is Completed?
                      </label>
                      { formData.isFinwiser && (
                        <div className="mb-2 text-sm">
                          <label htmlFor="enddate">Completion Date:</label>
                          <br />
                          <DatePicker
                            selected={formData.completionDate}
                            onChange={(date) => setFormData({ ...formData, completionDate: date })}
                            dateFormat="dd/MM/yyyy"
                            id="completionDate"
                            name="completionDate"
                            className="form-control h-8"
                          />
                          {fieldError("completionDate")}
                        </div>
                      )}
                    </div> 
                    <div className='mb-2'>  
                      <label>
                        <input className='mr-4' type="checkbox" checked={formData.isRecurring} onChange={(e) => setFormData({ ...formData, isRecurring: e.target.checked })} />
                        Is Recurring?
                      </label>
                    </div> 
                    <div className='mb-2'>  
                      <label>
                        <input className='mr-4' type="checkbox" checked={formData.isPriority} onChange={(e) => setFormData({ ...formData, isPriority: e.target.checked })} />
                        Is Priority?
                      </label>
                    </div> 
                    <div className="mb-2 text-sm">
                      <p className='text-white'>Finwiser Remarks:</p>
                      { showMicrophoneAlert ? (
                        <SpeechInputComponent
                          label="Finwiser Remarks"
                          name="finwiserRemarks"
                          value={formData.finwiserRemarks}
                          onChange={handleChange}
                          placeholder="Click Mic for Voice Input..."
                          maxLength="1000"
                        />
                      ) : (
                        <textarea
                          label="Finwiser Remarks"
                          name="finwiserRemarks"
                          value={formData.finwiserRemarks}
                          onChange={handleChange}
                          placeholder="Write here for Input..."
                          maxLength="1000"
                          style={{
                            border: '1px solid #ccc',
                            padding: '2px',
                            backgroundColor: '#f0f0f0', 
                            color: '#000000',
                            maxWidth: '100%', 
                            maxHeight: '150px' 
                          }}
                        />
                      )}
                      {fieldError("finwiserRemarks")}
                      {isCheckedAISupport && formData.finwiserRemarks!== '' && (
                      <div className="mb-1">
                        <AILightComponent param1={"Finwiser Remarks"} param2={formData.finwiserRemarks}/>
                      </div>
                      )}
                    </div>
                    <div className="flex flex-col justify-center text-white">
                      <p>Status:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.status}
                        onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                        placeholder="Enter Status"
                      />
                    </div>
                </div>
              )}

              { activeTab === "FOCUS" && (  
                <div className="border rounded-lg p-4 shadow-md bg-black border-green-800">  
                  <div className="mb-4 flex flex-col">
                    <label>
                      <input className='mr-4' type="checkbox" checked={formData.isSports} onChange={(e) => setFormData({ ...formData, isSports: e.target.checked })} />
                      For FOCUS - Functional Optimization for Coaching, Understanding and Success (Sports, Fitness, Wellness) Program?
                    </label>
                  </div>
                  <div className="flex flex-col justify-center text-white">
                      <p>Player:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.player}
                        onChange={(e) => setFormData({ ...formData, player: e.target.value })}
                        placeholder="Enter Player Code"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Coach:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.coach}
                        onChange={(e) => setFormData({ ...formData, coach: e.target.value })}
                        placeholder="Enter Coach Code"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Assistant Coach:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.assistantCoach}
                        onChange={(e) => setFormData({ ...formData, assistantCoach: e.target.value })}
                        placeholder="Enter Assistant Coach Id/Code"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Ground:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.ground}
                        onChange={(e) => setFormData({ ...formData, ground: e.target.value })}
                        placeholder="Enter Ground Name"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Tournament Name:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.tournament}
                        onChange={(e) => setFormData({ ...formData, tournament: e.target.value })}
                        placeholder="Enter Tournament Name"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white">
                      <p>Branch / Franchise Id/Code/Name:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.branch}
                        onChange={(e) => setFormData({ ...formData, branch: e.target.value })}
                        placeholder="Enter Branch"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>State:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.state}
                        onChange={(e) => setFormData({ ...formData, state: e.target.value })}
                        placeholder="Enter State Name"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Country:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.country}
                        onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                      />
                    </div>
                    <div className='mb-2'>  
                      <label>
                        <input className='mr-4' type="checkbox" checked={formData.isCompleted} onChange={(e) => setFormData({ ...formData, isCompleted: e.target.checked })} />
                        Is Completed?
                      </label>
                      { formData.isSports && (
                        <div className="mb-2 text-sm">
                          <label htmlFor="enddate">Completion Date:</label>
                          <br />
                          <DatePicker
                            selected={formData.completionDate}
                            onChange={(date) => setFormData({ ...formData, completionDate: date })}
                            dateFormat="dd/MM/yyyy"
                            id="completionDate"
                            name="completionDate"
                            className="form-control h-8"
                          />
                          {fieldError("completionDate")}
                        </div>
                      )}
                    </div> 
                    <div className='mb-2'>  
                      <label>
                        <input className='mr-4' type="checkbox" checked={formData.isRecurring} onChange={(e) => setFormData({ ...formData, isRecurring: e.target.checked })} />
                        Is Recurring?
                      </label>
                    </div> 
                    <div className='mb-2'>  
                      <label>
                        <input className='mr-4' type="checkbox" checked={formData.isPriority} onChange={(e) => setFormData({ ...formData, isPriority: e.target.checked })} />
                        Is Priority?
                      </label>
                    </div> 
                    <div className="mb-2 text-sm">
                      <p className='text-white'>Sports & Fitness Remarks:</p>
                      { showMicrophoneAlert ? (
                        <SpeechInputComponent
                          label="Sports & Fitness Remarks"
                          name="sportsRemarks"
                          value={formData.sportsRemarks}
                          onChange={handleChange}
                          placeholder="Click Mic for Voice Input..."
                          maxLength="1000"
                        />
                      ) : (
                        <textarea
                          label="Sports & Fitness Remarks"
                          name="sportsRemarks"
                          value={formData.sportsRemarks}
                          onChange={handleChange}
                          placeholder="Write here for Input..."
                          maxLength="1000"
                          style={{
                            border: '1px solid #ccc',
                            padding: '2px',
                            backgroundColor: '#f0f0f0', 
                            color: '#000000',
                            maxWidth: '100%', 
                            maxHeight: '150px' 
                          }}
                        />
                      )}
                      {fieldError("sportsRemarks")}
                      {isCheckedAISupport && formData.sportsRemarks!== '' && (
                      <div className="mb-1">
                        <AILightComponent param1={"Sports & Fitness  Remarks"} param2={formData.sportsRemarks}/>
                      </div>
                      )}
                    </div>
                    <div className="flex flex-col justify-center text-white">
                      <p>Status:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.status}
                        onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                        placeholder="Enter Status"
                      />
                    </div>
                </div>
              )}

              { activeTab === "HEALTHIER" && (   
                <div className="border rounded-lg p-4 shadow-md bg-black border-red-800">  
                  <div className="mb-4 flex flex-col">
                    <label>
                      <input className='mr-4' type="checkbox" checked={formData.isHealth} onChange={(e) => setFormData({ ...formData, isHealth: e.target.checked })} />
                      For HEALTHIER - Holistic Efficiency for Achieving Long-Term Health & Enhanced Results Program?
                    </label>
                  </div>
                  <div className="flex flex-col justify-center text-white">
                      <p>Patient:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.patient}
                        onChange={(e) => setFormData({ ...formData, patient: e.target.value })}
                        placeholder="Enter Patient Code"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Doctor:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.doctor}
                        onChange={(e) => setFormData({ ...formData, doctor: e.target.value })}
                        placeholder="Enter Doctor Code"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Speciality:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.speciality}
                        onChange={(e) => setFormData({ ...formData, speciality: e.target.value })}
                        placeholder="Enter Speciality"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Lead Doctor:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.headDoctor}
                        onChange={(e) => setFormData({ ...formData, headDoctor: e.target.value })}
                        placeholder="Enter Head/Lead Doctor Code"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Hospital:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.hospital}
                        onChange={(e) => setFormData({ ...formData, hospital: e.target.value })}
                        placeholder="Enter Hospital Name"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white">
                      <p>Branch/Place:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.branch}
                        onChange={(e) => setFormData({ ...formData, branch: e.target.value })}
                        placeholder="Enter Branch"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>State:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.state}
                        onChange={(e) => setFormData({ ...formData, state: e.target.value })}
                        placeholder="Enter State Name"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Country:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.country}
                        onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                      />
                    </div>
                    <div className='mb-2'>  
                      <label>
                        <input className='mr-4' type="checkbox" checked={formData.isCompleted} onChange={(e) => setFormData({ ...formData, isCompleted: e.target.checked })} />
                        Is Completed?
                      </label>
                      { formData.isHealth && (
                        <div className="mb-2 text-sm">
                          <label htmlFor="enddate">Completion Date:</label>
                          <br />
                          <DatePicker
                            selected={formData.completionDate}
                            onChange={(date) => setFormData({ ...formData, completionDate: date })}
                            dateFormat="dd/MM/yyyy"
                            id="completionDate"
                            name="completionDate"
                            className="form-control h-8"
                          />
                          {fieldError("completionDate")}
                        </div>
                      )}
                    </div> 
                    <div className='mb-2'>  
                      <label>
                        <input className='mr-4' type="checkbox" checked={formData.isRecurring} onChange={(e) => setFormData({ ...formData, isRecurring: e.target.checked })} />
                        Is Recurring?
                      </label>
                    </div> 
                    <div className='mb-2'>  
                      <label>
                        <input className='mr-4' type="checkbox" checked={formData.isPriority} onChange={(e) => setFormData({ ...formData, isPriority: e.target.checked })} />
                        Is Priority?
                      </label>
                    </div> 
                    <div className="mb-2 text-sm">
                      <p className='text-white'>HEALTHIER Remarks:</p>
                      { showMicrophoneAlert ? (
                        <SpeechInputComponent
                          label="HEALTHIER Remarks"
                          name="healthRemarks"
                          value={formData.healthRemarks}
                          onChange={handleChange}
                          placeholder="Click Mic for Voice Input..."
                          maxLength="1000"
                        />
                      ) : (
                        <textarea
                          label="HEALTHIER Remarks"
                          name="healthRemarks"
                          value={formData.healthRemarks}
                          onChange={handleChange}
                          placeholder="Write here for Input..."
                          maxLength="1000"
                          style={{
                            border: '1px solid #ccc',
                            padding: '2px',
                            backgroundColor: '#f0f0f0', 
                            color: '#000000',
                            maxWidth: '100%', 
                            maxHeight: '150px' 
                          }}
                        />
                      )}
                      {fieldError("healthRemarks")}
                      {isCheckedAISupport && formData.healthRemarks!== '' && (
                      <div className="mb-1">
                        <AILightComponent param1={"HEALTHIER Remarks"} param2={formData.healthRemarks}/>
                      </div>
                      )}
                    </div>
                    <div className="flex flex-col justify-center text-white">
                      <p>Status:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.status}
                        onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                        placeholder="Enter Status"
                      />
                    </div>
                </div>
              )}

              { activeTab === "Vardhini" && (   
                <div className="border rounded-lg p-4 shadow-md bg-black border-green-400">  
                  <div className="mb-4 flex flex-col">
                    <label>
                      <input className='mr-4' type="checkbox" checked={formData.isAgri} onChange={(e) => setFormData({ ...formData, isAgri: e.target.checked })} />
                      For Vardhini - "Growth Enhancer," symbolizing agricultural growth through problem-solving.
                    </label>
                  </div>
                  <div className="flex flex-col justify-center text-white">
                      <p>Farmer:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.farmer}
                        onChange={(e) => setFormData({ ...formData, farmer: e.target.value })}
                        placeholder="Enter Farmer Code"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Helper:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.helper}
                        onChange={(e) => setFormData({ ...formData, helper: e.target.value })}
                        placeholder="Enter Helper Code"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Supervisor:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.supervisor}
                        onChange={(e) => setFormData({ ...formData, supervisor: e.target.value })}
                        placeholder="Enter Supervisor Code..."
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Manager:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.manager}
                        onChange={(e) => setFormData({ ...formData, manager: e.target.value })}
                        placeholder="Enter Manager Code"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Area:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.area}
                        onChange={(e) => setFormData({ ...formData, area: e.target.value })}
                        placeholder="Enter Area Name"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white">
                      <p>Crop:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.crop}
                        onChange={(e) => setFormData({ ...formData, crop: e.target.value })}
                        placeholder="Enter Crop Name"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>State:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.state}
                        onChange={(e) => setFormData({ ...formData, state: e.target.value })}
                        placeholder="Enter State Name"
                      />
                    </div>
                    <div className="flex flex-col justify-center text-white mt-2">
                      <p>Country:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.country}
                        onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                      />
                    </div>
                    <div className='mb-2'>  
                      <label>
                        <input className='mr-4' type="checkbox" checked={formData.isCompleted} onChange={(e) => setFormData({ ...formData, isCompleted: e.target.checked })} />
                        Is Completed?
                      </label>
                      { formData.isAgri && (
                        <div className="mb-2 text-sm">
                          <label htmlFor="enddate">Completion Date:</label>
                          <br />
                          <DatePicker
                            selected={formData.completionDate}
                            onChange={(date) => setFormData({ ...formData, completionDate: date })}
                            dateFormat="dd/MM/yyyy"
                            id="completionDate"
                            name="completionDate"
                            className="form-control h-8"
                          />
                          {fieldError("completionDate")}
                        </div>
                      )}
                    </div> 
                    <div className='mb-2'>  
                      <label>
                        <input className='mr-4' type="checkbox" checked={formData.isRecurring} onChange={(e) => setFormData({ ...formData, isRecurring: e.target.checked })} />
                        Is Recurring?
                      </label>
                    </div> 
                    <div className='mb-2'>  
                      <label>
                        <input className='mr-4' type="checkbox" checked={formData.isPriority} onChange={(e) => setFormData({ ...formData, isPriority: e.target.checked })} />
                        Is Priority?
                      </label>
                    </div> 
                    <div className="mb-2 text-sm">
                      <p className='text-white'>Vardhini Remarks:</p>
                      { showMicrophoneAlert ? (
                        <SpeechInputComponent
                          label="Vardhini Remarks"
                          name="agriRemarks"
                          value={formData.agriRemarks}
                          onChange={handleChange}
                          placeholder="Click Mic for Voice Input..."
                          maxLength="1000"
                        />
                      ) : (
                        <textarea
                          label="Vardhini Remarks"
                          name="agriRemarks"
                          value={formData.agriRemarks}
                          onChange={handleChange}
                          placeholder="Write here for Input..."
                          maxLength="1000"
                          style={{
                            border: '1px solid #ccc',
                            padding: '2px',
                            backgroundColor: '#f0f0f0', 
                            color: '#000000',
                            maxWidth: '100%', 
                            maxHeight: '150px' 
                          }}
                        />
                      )}
                      {fieldError("agriRemarks")}
                      {isCheckedAISupport && formData.agriRemarks!== '' && (
                      <div className="mb-1">
                        <AILightComponent param1={"Vardhini Remarks"} param2={formData.agriRemarks}/>
                      </div>
                      )}
                    </div>
                    <div className="flex flex-col justify-center text-white">
                      <p>Status:</p>
                      <input
                        type="text"
                        className="profile-input text-black"
                        style={{ maxWidth: '250px', height: '34px', lineHeight: '24px' }}
                        value={formData.status}
                        onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                        placeholder="Enter Status"
                      />
                    </div>
                </div>
              )}

              {activeTab === "Examples" && (
                <div className="min-h-[30vh] flex flex-row gap-4 border rounded-lg p-4 shadow-md bg-black border-purple-400 mt-2">
                  <button
                    className="bg-purple-600 text-white text-sm px-6 py-3 rounded-md shadow hover:bg-purple-800 transition duration-300"
                    onClick={handleNavigateToExampleDB}
                  >
                    I Need Quick Examples
                  </button>

                  <button
                    className="bg-blue-500 text-white text-sm px-6 py-3 rounded-md shadow hover:bg-blue-600 transition duration-300"
                    onClick={handleNavigateToExtensionExample}
                  >
                    Extensive Study Examples
                  </button>
                </div>
              )}

              {activeTab === "Extension" && (
                <div className="border rounded-lg p-4 shadow-md bg-gray-800 mt-2">
                  <button
                    className="bg-purple-600 text-white text-sm px-6 py-3 rounded-md shadow hover:bg-purple-800 transition duration-300"
                    onClick={handleNavigateToExtensionExample}
                  >
                    Extensive Study Examples
                  </button>
                  <button
                    className="bg-blue-500 text-white text-sm px-6 py-3 rounded-md shadow hover:bg-blue-600 transition duration-300"
                    onClick={handleNavigateToExtension}
                    disabled={mode === "add"}
                  >
                    GoTo Extensive Form
                  </button>
                </div>
              )}

              {activeTab === "Services" && (
                <div className="border rounded-lg p-4 shadow-md bg-gray-800 mt-2">
                  <button
                    className="bg-lime-600 text-white text-sm px-6 py-3 rounded-md shadow hover:bg-lime-800 transition duration-300"
                    onClick={handleNavigateToCounsellor}
                  >
                    Personal Counsellor
                  </button>
                  <button
                    className="bg-orange-600 text-white text-sm px-6 py-3 rounded-md shadow hover:bg-orange-800 transition duration-300"
                    onClick={handleNavigateToConsultant}
                  >
                    Company Consultant
                  </button>
                </div>
              )}

              {activeTab === "Help" && (
                <div className="border rounded-lg p-4 shadow-md bg-gray-800 mt-2">
                  <div className="p-6 bg-black text-white border border-blue-400 rounded-lg shadow-md">
                    <h1 className="text-xl lg:text-2xl font-bold text-yellow-200 mb-4">Think5Whys RCA Input Form - Help Guide</h1>
                    
                    <section className="mb-6">
                      <h2 className="text-xl font-semibold text-white mb-2">Purpose of the Form</h2>
                      <p className="text-white">
                        This form allows you to systematically record, analyze, and resolve issues using the 5 Whys method. It includes fields to capture problem details, root causes, and associated metadata.
                      </p>
                    </section>
                    
                    <section className="mb-6">
                      <h2 className="text-xl font-semibold text-white mb-2">Steps to Use the Form</h2>
                      <ol className="list-decimal pl-6 text-gray-200">
                        <li>Start by selecting the <strong>RCA Type</strong> (e.g., Problem).</li>
                        <li>Fill in the <strong>Category</strong> and <strong>Subcategory</strong> to classify the issue.</li>
                        <li>Specify the <strong>Concern Area</strong> or Goal Title (mandatory).</li>
                        <li>Write a detailed <strong>Problem Statement</strong> (max 1000 characters).</li>
                        <li>Complete the <strong>5 Why Analysis</strong>:
                          <ul className="list-disc pl-6 mt-2">
                            <li>Each "Why" should address a cause of the previous "Why."</li>
                            <li>Limit each "Why" to 1000 characters.</li>
                          </ul>
                        </li>
                        <li>Summarize your findings in the <strong>Root Cause Statement</strong> (max 2000 characters).</li>
                        <li>Add <strong>Tags</strong>, <strong>Remarks</strong>, or a <strong>Summary</strong> as needed.</li>
                      </ol>
                    </section>
                    
                    <section className="mb-6">
                      <h2 className="text-xl font-semibold text-white mb-2">Validation Rules</h2>
                      <ul className="list-disc pl-6 text-gray-200">
                        <li><strong>Category:</strong> Required and must not exceed 50 characters.</li>
                        <li><strong>Subcategory:</strong> Optional but cannot exceed 50 characters.</li>
                        <li><strong>Concern Area:</strong> Required and must not exceed 100 characters.</li>
                        <li><strong>Why Analysis:</strong> Each field limited to 1000 characters.</li>
                        <li><strong>Root Cause Statement:</strong> Limited to 2000 characters.</li>
                        <li><strong>Tags:</strong> Cannot exceed 100 characters.</li>
                      </ul>
                    </section>
                    
                    <section className="mb-6">
                      <h2 className="text-xl font-semibold text-white mb-2">Specialized Sections</h2>
                      <p className="text-white">Certain tabs include domain-specific fields:</p>
                      <ul className="list-disc pl-6 text-gray-200">
                        <li><strong>SHEETAL:</strong> Includes fields for district, sub-district, and block.</li>
                        <li><strong>INSPIRE:</strong> Targets educational institutions with fields like student, school, and teacher.</li>
                        <li><strong>Finwiser:</strong> Caters to financial scenarios with fields like branch, manager, and customer.</li>
                        <li><strong>Healthier:</strong> Designed for healthcare with fields like doctor, patient, and hospital.</li>
                        <li><strong>Sports:</strong> Focuses on sports management with fields like coach, player, and tournament.</li>
                      </ul>
                    </section>
                    
                    <section className="mb-6">
                      <h2 className="text-xl font-semibold text-white mb-2">Navigation</h2>
                      <p className="text-white">
                        Use the tab navigation to explore different sections of the form:
                      </p>
                      <ul className="list-disc pl-6 text-gray-200">
                        <li><strong>Init:</strong> Basic setup and initialization.</li>
                        <li><strong>RCA:</strong> Core 5 Whys analysis.</li>
                        <li><strong>Solution:</strong> Document quick solutions and actions.</li>
                        <li><strong>Others:</strong> Capture additional notes and remarks.</li>
                      </ul>
                    </section>
                    
                    <section className="mb-6">
                      <h2 className="text-xl font-semibold text-white mb-2">Key Features</h2>
                      <ul className="list-disc pl-6 text-gray-200">
                        <li>Fields for timestamps, owners, and metadata (e.g., isApproved, isFinal).</li>
                        <li>Support for recurring and priority RCAs.</li>
                        <li>Ability to link tasks and RCAs.</li>
                        <li>Geographical metadata (country, state, village).</li>
                      </ul>
                    </section>
                    
                    <section className="mb-6">
                      <h2 className="text-xl font-semibold text-white mb-2">Tips</h2>
                      <ul className="list-disc pl-6 text-gray-200">
                        <li>Regularly save your progress to avoid data loss.</li>
                        <li>Use descriptive tags for better searchability.</li>
                        <li>Collaborate with team members by sharing RCA codes.</li>
                      </ul>
                    </section>
                    
                    <footer className="mt-6 border-t pt-4">
                      <p className="text-yellow-200 text-sm">
                        For more assistance, refer to the <strong>Help</strong> tab or contact support.
                      </p>
                    </footer>
                  </div>

                </div>
              )}

              {activeTab === "Need of RCA" && (
                <div className="border rounded-lg p-4 shadow-md bg-black mt-2">
                  <div className="p-6 bg-black rounded-lg shadow-md">
                    <h1 className="text-xl lg:text-2xl font-bold mb-4 text-yellow-200 text-center">
                      The Power of 5 Why Analysis and Its Benefits
                    </h1>

                    {/* Why Everyone Should Do 5 Why Analysis */}
                    <section className="mb-6">
                      <h2 className="text-lg lg:text-xl font-semibold mb-2 text-white">
                        Why Everyone Should Do 5 Why Analysis
                      </h2>
                      <ul className="list-disc ml-8 text-white">
                        <li>
                          <strong>Simplicity and Accessibility:</strong> Easy to use without needing
                          specialized tools or expertise.
                        </li>
                        <li>
                          <strong>Systematic Problem-Solving:</strong> Focuses on investigating issues step by
                          step.
                        </li>
                        <li>
                          <strong>Prevention Over Reaction:</strong> Targets root causes to prevent recurrence.
                        </li>
                        <li>
                          <strong>Enhanced Decision-Making:</strong> Makes decisions more informed and
                          goal-aligned.
                        </li>
                        <li>
                          <strong>Fosters Continuous Improvement:</strong> Promotes a culture of learning and
                          growth.
                        </li>
                      </ul>
                    </section>

                    {/* Benefits of Having a 5 Whys RCA Database */}
                    <section className="mb-6">
                      <h2 className="text-lg lg:text-xl font-semibold mb-2 text-white">
                        Benefits of Having a 5 Whys RCA Database
                      </h2>

                      <div className="mb-4">
                        <h3 className="text-lg lg:text-xl font-medium text-white">For Self</h3>
                        <ol className="list-decimal ml-8 text-white">
                          <li>
                            <strong>Track Personal Growth:</strong> Provides a roadmap for improvement by
                            documenting challenges.
                          </li>
                          <li>
                            <strong>Improved Productivity:</strong> Saves time by addressing recurring issues.
                          </li>
                          <li>
                            <strong>Learning and Reflection:</strong> Acts as a personal knowledge repository.
                          </li>
                        </ol>
                      </div>

                      <div>
                        <h3 className="text-lg lg:text-xl font-medium text-white">For Work</h3>
                        <ol className="list-decimal ml-8 text-white">
                          <li>
                            <strong>Knowledge Retention:</strong> Avoids re-investigating recurring problems.
                          </li>
                          <li>
                            <strong>Data-Driven Improvement:</strong> Identifies trends for targeted solutions.
                          </li>
                          <li>
                            <strong>Collaboration and Transparency:</strong> Enhances teamwork and clarity.
                          </li>
                          <li>
                            <strong>Supports Compliance:</strong> Demonstrates due diligence in regulated
                            environments.
                          </li>
                        </ol>
                      </div>
                    </section>

                    {/* Benefits of a Cloud-Based Comprehensive 5 Whys RCA Online Tool */}
                    <section className="mb-6 text-white">
                      <h2 className="text-lg lg:text-xl font-semibold mb-2 text-white">
                        Benefits of a Cloud-Based Comprehensive 5 Whys RCA Online Tool
                      </h2>
                      <ul className="list-disc ml-8">
                        <li>
                          <strong>Anywhere Access:</strong> Accessible from any device for convenience.
                        </li>
                        <li>
                          <strong>Real-Time Collaboration:</strong> Enables teamwork across geographies.
                        </li>
                        <li>
                          <strong>Automated Features:</strong> Streamlines processes with templates and
                          intelligent prompts.
                        </li>
                        <li>
                          <strong>Data Security:</strong> Protects sensitive information with robust security.
                        </li>
                        <li>
                          <strong>Comprehensive Insights:</strong> Advanced analytics reveal trends and success
                          rates.
                        </li>
                        <li>
                          <strong>Scalability:</strong> Adaptable for individuals or large organizations.
                        </li>
                        <li>
                          <strong>Integration Capabilities:</strong> Seamlessly integrates with other tools.
                        </li>
                        <li>
                          <strong>Cost-Effectiveness:</strong> Reduces infrastructure and IT support costs.
                        </li>
                        <li>
                          <strong>Environmentally Friendly:</strong> Reduces reliance on paper and physical
                          storage.
                        </li>
                      </ul>
                    </section>

                    {/* Summary of Benefits */}
                    <section>
                      <h2 className="text-lg lg:text-xl font-semibold mb-2 text-white">Summary of Benefits</h2>
                      <div className="overflow-x-auto text-white">
                        <table className="table-auto w-full border-collapse border border-gray-300 text-left">
                          <thead className="bg-gray-200 text-gray-200">
                            <tr>
                              <th className="border border-gray-300 px-4 py-2">Aspect</th>
                              <th className="border border-gray-300 px-4 py-2">Key Benefits</th>
                            </tr>
                          </thead>
                          <tbody className="text-gray-200">
                            <tr className='text-gray-200'>
                              <td className="border border-gray-300 px-4 py-2 text-gray-200">
                                <strong>Personal 5 Whys Practice</strong>
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-gray-200">
                                Self-growth, informed decisions, prevention of recurring issues, productivity
                                boost.
                              </td>
                            </tr>
                            <tr>
                              <td className="border border-gray-300 px-4 py-2 text-gray-200">
                                <strong>5 Whys RCA Database</strong>
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-gray-200">
                                Historical insights, collaboration, knowledge retention, and improved processes.
                              </td>
                            </tr>
                            <tr>
                              <td className="border border-gray-300 px-4 py-2 text-gray-200">
                                <strong>Cloud-Based Tool</strong>
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-gray-200">
                                Real-time access, automation, security, scalability, and comprehensive analytics.
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </section>
                  </div>
                </div>
              )}

              <div className="border rounded-lg p-4 shadow-md bg-black mt-2">
                <div className="flex justify-center">
                  {Object.keys(formErrors).length > 0 && (
                    <div className="form-errors text-red-300 justify-center items-center">
                      {Object.keys(formErrors).map((key) => (
                        <div
                          className="flex justify-center items-center"
                          key={key}
                        >
                          {formErrors[key]}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div className="flex justify-center">
                  <button
                    className="bg-primary text-white px-4 py-2 font-medium hover:bg-primary-dark"
                    onClick={handleSubmit}
                    disabled={!rcaBookStatus}
                  >
                    {mode === "add" ? "Add New" : "Update"}
                  </button>
                  <button
                    className="ml-4 bg-red-500 text-white px-4 py-2 font-medium"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <footer className="bg-gray-900 border-t border-blue-400 text-gray-400 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>   
    </div>
  );
}

export default Rca